// @ts-nocheck
/* eslint-disable no-unused-vars -- Payment Gateway section moved to ProfilePage.js; commented code below keeps these refs */
import UilellipsisH from '@iconscout/react-unicons/icons/uil-ellipsis-h';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Form, Input, Modal, Spin } from 'antd';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { CardFrame } from './style';
import { Dropdown } from '../../dropdown/dropdown';
import Heading from '../../heading/heading';
import { Button } from '../../buttons/buttons';

import {
  completeStripeOnboarding,
  completeStripeOnboardingSuccess,
  verifyStripeOnboardingStatus,
} from '../../../redux/payment/actions';
import { almaOnboardingDetails } from '../../../redux/authentication/actions';
import { PaymentCardWrapper, PaymentMethodSection } from '../paymentMethod/style';

import StripeIcon from '../../../static/img/Stripe_icon.png';
import AlmaIcon from '../../../static/img/Alma_icon.png';
import PaymentCard from '../paymentMethod/Card';
// import Switch from '../../language-change-switch/Switch';
// import { he } from 'date-fns/locale';

function Cards(props) {
  const dispatch = useDispatch();
  const [stripeOnboardingInfoShow, setStripeOnboardingInfoShow] = useState(false);
  const [almaOnboardingInfoShow, setAlmaOnboardingInfoShow] = useState(false);

  const [stripeOnboardingLinkShow, setStripeOnboardingLinkShow] = useState(false);
  const [almaOnboardingLinkShow, setAlmaOnboardingLinkShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);
  const [stripeOnboardingLink, setStripeOnboardingLink] = useState('');
  const [hasStarted, setHasStarted] = useState(false);
  const UsersProfile = useSelector((state) => state?.auth?.user);

  const stripeOnboardingStatus = useSelector((state) => state?.payment?.stripeOnboardingStatus);
  const almaAccountDetails = useSelector((state) => state?.auth?.almaOnboardingDetails);

  const verifyStripeOnboarding = useSelector((state) => state.payment.verifyStripeOnboardingStatus);
  const language = useSelector((state) => state?.auth?.language);
  const loaderStatus = useSelector((state) => state.loader.transparentLoader);

  const {
    title,
    titleDescription,
    children,
    more,
    moreText,
    size,
    headless,
    caption,
    isbutton,
    onboardingDone,
    bodyStyle,
    headStyle,
    border,
    bodypadding,
    className,
    isProfilePage,
    createButton,
    icon,
    titleStyle,
    titleDescriptionStyle,
    titlePadding,
    extra,
  } = props;

  const renderIcon = () => {
    if (React.isValidElement(icon)) return icon;
    if (typeof icon === 'function' || (typeof icon === 'object' && icon !== null && icon.$$typeof))
      return React.createElement(icon);
    return icon;
  };

  const titleContent = title ? (
    <span className="card-title-with-icon">
      {icon && (
        <button
          className="ant-card-head-icon"
          style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
          type="button"
          tabIndex={0}
          onClick={() => window.history.back()}
        >
          {renderIcon()}
        </button>
      )}
      <span className="ant-card-head-title-wrapper" style={{ width: '100%' }}>
        <span className="ant-card-head-title" style={titleStyle && titleStyle}>
          {title}
        </span>
        {titleDescription && (
          <span className="ant-card-head-title-description" style={titleDescriptionStyle && titleDescriptionStyle}>
            {titleDescription}
          </span>
        )}
      </span>
    </span>
  ) : (
    title
  );

  const [form] = Form.useForm();
  const completeStripeOnboardingHandler = () => {
    dispatch(completeStripeOnboarding());
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  };
  const handleAlmaOnboardingHandler = () => {
    setAlmaOnboardingLinkShow(true);
  };

  let displayMessage;
  if (!hasStarted) {
    displayMessage = <>{language?.content?.PENDING}</>;
  } else if (isRefreshLoading && loaderStatus) {
    displayMessage = <>{language?.content?.PROCESSING}</>;
  } else {
    displayMessage = <>{language?.content?.PENDING}</>;
  }
  const showStripeOnboardingInfoHandler = () => {
    setStripeOnboardingInfoShow(true);
  };
  const showAlmaOnboardingInfoHandler = () => {
    setAlmaOnboardingInfoShow(true);
  };
  const copyHandler = () => {
    navigator.clipboard.writeText(stripeOnboardingLink);
    toast.success(language?.content?.ONBOARDING_LINK_COPIED);
  };
  const refreshPageHandler = () => {
    dispatch(verifyStripeOnboardingStatus());
    setIsRefreshLoading(true);
    setHasStarted(true);
  };
  useEffect(() => {
    if (stripeOnboardingStatus) {
      setStripeOnboardingLink(stripeOnboardingStatus?.url);
      dispatch(completeStripeOnboardingSuccess(null));
      setStripeOnboardingLinkShow(true);
    }
  }, [stripeOnboardingStatus]);

  useEffect(() => {
    if (verifyStripeOnboarding) {
      setStripeOnboardingLinkShow(false);
    }
  }, [verifyStripeOnboarding]);
  useEffect(() => {
    if (almaAccountDetails?.data) {
      setAlmaOnboardingLinkShow(false);
    }
  }, [almaAccountDetails]);

  const handleAlmaOnboarding = async (value) => {
    await dispatch(almaOnboardingDetails(value));
  };

  // const validateSecretKeys = (_, value) => {
  //   const testSecretKey = form.getFieldValue('test_secret_key');
  //   const liveSecretKey = form.getFieldValue('live_secret_key');

  //   if (!testSecretKey || !liveSecretKey) {
  //     return Promise.reject(
  //       new Error(language?.message?.error?.ERR018 || 'Either Test Secret Key or Live Secret Key is required'),
  //     );
  //   }
  //   return Promise.resolve();
  // };
  if (!headless && isProfilePage) {
    return (
      <>
        <CardFrame
          size={size}
          // title={title}
          title={titleContent}
          bodyStyle={bodyStyle && bodyStyle}
          headStyle={headStyle && headStyle}
          bordered={border}
          className={className}
          bodypadding={bodypadding && bodypadding}
          extra={
            <>
              {/* <Switch /> */}
              {extra && extra}
              {more && (
                <Dropdown content={more} placement="bottom">
                  <Link onClick={(e) => e.preventDefault()} to="#">
                    {!moreText ? <UilellipsisH /> : 'More'}
                  </Link>
                </Dropdown>
              )}
            </>
          }
          style={{ width: '100%' }}
        >
          {children}
          {/* ========== Payment Gateway section moved to ProfilePage.js (last section "Payment Gateway") ========== */}
          {/* {(UsersProfile?.status !== 'not_applicable' ||
            (almaAccountDetails &&
              Object.keys(almaAccountDetails).length > 0 &&
              almaAccountDetails?.status &&
              almaAccountDetails?.status !== 'not_applicable')) && (
            <PaymentMethodSection className="paymentCardFrame" paddingLeftRight="0px">
              <div className="heading">{language?.content?.PAYMENT_GATEWAY || 'Payment Gateway'}</div>

              <PaymentCardWrapper>
                {UsersProfile && UsersProfile?.status !== 'not_applicable' && UsersProfile?.status && (
                  <PaymentCard
                    Icon={StripeIcon}
                    status={UsersProfile?.status}
                    infoIcon={UsersProfile?.status === 'pending'}
                    type="stripe"
                    handleClick={completeStripeOnboardingHandler}
                    infoBtn={showStripeOnboardingInfoHandler}
                  />
                )}
                {almaAccountDetails &&
                  Object.keys(almaAccountDetails).length > 0 &&
                  almaAccountDetails?.status &&
                  almaAccountDetails?.status !== 'not_applicable' && (
                    <PaymentCard
                      Icon={AlmaIcon}
                      infoIcon={almaAccountDetails?.status === 'pending'}
                      status={almaAccountDetails?.status}
                      content={almaAccountDetails?.label_status}
                      handleClick={handleAlmaOnboardingHandler}
                      type="alma"
                      infoBtn={showAlmaOnboardingInfoHandler}
                    />
                  )}
              </PaymentCardWrapper>
            </PaymentMethodSection>
          )} */}
        </CardFrame>

        {/* ========== Payment Gateway modals moved to ProfilePage.js ========== */}
        {/* <Modal
          title={language?.content?.ALMA_ONBOARDING || 'Alma Onboarding'}
          visible={almaOnboardingLinkShow}
          footer={null}
          onCancel={() => setAlmaOnboardingLinkShow(false)}
          afterClose={() => form.resetFields()}
          width={400}
        >
          <Form
            form={form}
            layout="vertical"
            name={language?.content?.ALMA_ONBOARDING || 'Alma Onboarding'}
            onFinish={handleAlmaOnboarding}
            initialValues={{
              merchant_id: almaAccountDetails?.data?.merchant_id || '',
              test_secret_key: almaAccountDetails?.data?.test_secret_key || '',
              live_secret_key: almaAccountDetails?.data?.live_secret_key || '',
            }}
          >
            <Form.Item
              name="merchant_id"
              label={language?.content?.MERCHANT_ID_LABEL || 'Merchant ID'}
              rules={[{ required: true, message: language?.message?.error.ERR078 }]}
            >
              <Input placeholder={language?.content.ENTER_MERCHANT_ID_PLACEHOLDER} maxLength={100} />
            </Form.Item>
            <Form.Item
              name="test_secret_key"
              label={language?.content.TEST_SECRET_KEY_LABEL || 'Test Secret Key'}
              rules={[{ required: true, message: language?.message?.error.ERR079 }]}
            >
              <Input placeholder={language?.content.ENTER_TEST_SECRET_KEY_PLACEHOLDER} maxLength={100} />
            </Form.Item>
            <Form.Item
              name="live_secret_key"
              label={language?.content?.LIVE_SECRET_KEY_LABEL || 'Live Secret Key'}
              rules={[{ required: true, message: language?.message?.error.ERR080 }]}
            >
              <Input placeholder={language?.content?.ENTER_LIVE_SECRET_KEY_PLACEHOLDER} maxLength={100} />
            </Form.Item>

            <Form.Item className="text-right m-0">
              <Button
                className="btn-create mt-25"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ backgroundColor: '#007dfc', marginTop: 0 }}
                disabled={!!isLoading}
              >
                {isLoading ? language?.content?.LOADING : language?.content?.SUBMIT}
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title=""
          visible={stripeOnboardingLinkShow}
          footer={null}
          onCancel={() => setStripeOnboardingLinkShow(false)}
          width={400}
        >
          <div style={{ marginTop: '50px', textAlign: 'center' }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 58 }} spin />} />
            <p className="mt-20">{language?.content?.LOADING}</p>
          </div>
          <button
            type="button"
            className="copy-url-btn cursor-pointer"
            onClick={() => copyHandler()}
            style={{ marginTop: '40px' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M21 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19a.3.3 0 0 0-.09 0a.9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3zm-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z"
              />
            </svg>{' '}
            {language?.content?.COPY_ONBOARDING_LINK}
          </button>
          <div className="text-center" style={{ borderTop: '1px solid #E0E0E0', marginTop: '18px' }}>
            <p style={{ marginTop: '16px', marginBottom: '0px' }}>
              {language?.content?.ONBOARDING_STATUS} : {displayMessage}
            </p>
            <button type="button" className="cursor-pointer refresh-btn" onClick={() => refreshPageHandler()}>
              {language?.content?.REFRESH_PAGE}
            </button>
          </div>
        </Modal>

        <Modal
          title={language?.content?.ONBOARDING_INFORMATION_TITLE}
          visible={almaOnboardingInfoShow}
          footer={null}
          onCancel={() => setAlmaOnboardingInfoShow(false)}
        >
          <p>{language?.content?.ONBOARDING_INFORMATION_ALMA}</p>
        </Modal>

        <Modal
          title={language?.content?.ONBOARDING_INFORMATION_TITLE}
          visible={stripeOnboardingInfoShow}
          footer={null}
          onCancel={() => setStripeOnboardingInfoShow(false)}
        >
          <p>{language?.content?.ONBOARDING_INFORMATION}</p>
        </Modal> */}
      </>
    );
  }

  return (
    <>
      {!headless ? (
        <>
          <CardFrame
            size={size}
            // title={title}
            title={titleContent}
            bodyStyle={bodyStyle && bodyStyle}
            headStyle={headStyle && headStyle}
            titlePadding={titlePadding}
            bordered={border}
            className={className}
            bodypadding={bodypadding && bodypadding}
            extra={
              <>
                {extra && extra}
                {/* <Switch /> */}
                {more && (
                  <Dropdown content={more} placement="bottom">
                    <Link onClick={(e) => e.preventDefault()} to="#">
                      {!moreText ? <UilellipsisH /> : 'More'}
                    </Link>
                  </Dropdown>
                )}
                {isbutton && (
                  <div className="">
                    <Button
                      className="btn-create"
                      type="secondary"
                      size="large"
                      style={{
                        background: '#ff0000d4',
                        border: 'none',
                        marginLeft: '8px',
                        height: '36px',
                        minWidth: '216px',
                      }}
                      onClick={() => completeStripeOnboardingHandler()}
                    >
                      {isLoading ? language?.content?.LOADING : language?.content?.COMPLETE_STRIPE_ONBOARDING}
                    </Button>
                    <Button
                      className="btn-info"
                      type="primary"
                      size="small"
                      onClick={() => showStripeOnboardingInfoHandler()}
                    >
                      i
                    </Button>
                  </div>
                )}
                {(onboardingDone || verifyStripeOnboarding) && (
                  <span className="color-success">{language?.content?.STRIPE_CONNECT_STATUS}</span>
                )}
                {createButton && (
                  <Button
                    type="primary"
                    size="large"
                    onClick={createButton.onClick}
                    style={{ marginLeft: '8px', ...createButton.style }}
                  >
                    {createButton.label}
                  </Button>
                )}
              </>
            }
            style={{ width: '100%' }}
          >
            {children}
          </CardFrame>
        </>
      ) : (
        <CardFrame
          bodypadding={bodypadding && bodypadding}
          titlePadding={titlePadding}
          bodyStyle={bodyStyle && bodyStyle}
          size={size}
          style={{ width: '100%' }}
          bordered={border}
          className={className}
        >
          {(title || createButton) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: caption ? '8px' : '16px',
              }}
            >
              {title && (
                <Heading as="h4">
                  {icon ? (
                    <span className="card-title-with-icon">
                      {renderIcon()}
                      <span>{title}</span>
                    </span>
                  ) : (
                    title
                  )}
                </Heading>
              )}
              {createButton && (
                <Button type="primary" size="large" onClick={createButton.onClick} style={createButton.style}>
                  {createButton.label}
                </Button>
              )}
            </div>
          )}
          {caption && <p>{caption}</p>}
          {children}
        </CardFrame>
      )}
      <Modal
        title={language?.content?.ONBOARDING_INFORMATION_TITLE}
        visible={stripeOnboardingInfoShow}
        footer={null}
        onCancel={() => setStripeOnboardingInfoShow(false)}
      >
        <p>{language?.content?.ONBOARDING_INFORMATION}</p>
      </Modal>
      <Modal
        title=""
        visible={stripeOnboardingLinkShow}
        footer={null}
        onCancel={() => setStripeOnboardingLinkShow(false)}
        width={400}
      >
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          {/* <Loader /> */}
          {/* <Spin indicator={<LoadingOutlined style={{ fontSize: 58 }} spin />} />
          <p className="mt-20">{language?.content?.LOADING}</p> */}
          <p className="mt-20">{language?.content?.STRIPE_ONBOARDING_INFO || 'Please copy the link and start your stripe onboarding process.'}</p>
        </div>
        <button
          type="button"
          className="copy-url-btn cursor-pointer"
          onClick={() => copyHandler()}
          style={{ marginTop: '40px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M21 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19a.3.3 0 0 0-.09 0a.9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3zm-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z"
            />
          </svg>{' '}
          {language?.content?.COPY_ONBOARDING_LINK}
        </button>
        <div className="text-center" style={{ borderTop: '1px solid #E0E0E0', marginTop: '18px' }}>
          <p style={{ marginTop: '16px', marginBottom: '0px' }}>
            {' '}
            {language?.content?.ONBOARDING_STATUS} : {displayMessage}
          </p>
          <button type="button" className="cursor-pointer refresh-btn" onClick={() => refreshPageHandler()}>
            {language?.content?.REFRESH_PAGE}
          </button>
        </div>
      </Modal>
    </>
  );
}

Cards.defaultProps = {
  border: false,
};

Cards.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  size: PropTypes.string,
  more: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  bodyStyle: PropTypes.object,
  headStyle: PropTypes.object,
  isbutton: PropTypes.bool,
  onboardingDone: PropTypes.bool,
  headless: PropTypes.bool,
  border: PropTypes.bool,
  caption: PropTypes.string,
  bodypadding: PropTypes.string,
  className: PropTypes.string,
  moreText: PropTypes.bool,
  isProfilePage: PropTypes.bool,
  createButton: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object,
  }),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  titleDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.node]),
  titleStyle: PropTypes.object,
  titleDescriptionStyle: PropTypes.object,
  titlePadding: PropTypes.string,
  extra: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export { Cards };
